var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16.2761 8 16.5 8.22386 16.5 8.5V17.2929L19.8131 13.9798C20.0084 13.7845 20.325 13.7845 20.5202 13.9798C20.7155 14.175 20.7155 14.4916 20.5202 14.6869L16.3536 18.8536C16.1583 19.0488 15.8417 19.0488 15.6464 18.8536L11.4798 14.6869C11.2845 14.4916 11.2845 14.175 11.4798 13.9798C11.675 13.7845 11.9916 13.7845 12.1869 13.9798L15.5 17.2929V8.5C15.5 8.22386 15.7239 8 16 8ZM8.5 18C8.77614 18 9 18.2239 9 18.5V21.8333C9 22.1428 9.12292 22.4395 9.34171 22.6583C9.5605 22.8771 9.85725 23 10.1667 23H21.8333C22.1428 23 22.4395 22.8771 22.6583 22.6583C22.8771 22.4395 23 22.1428 23 21.8333V18.5C23 18.2239 23.2239 18 23.5 18C23.7761 18 24 18.2239 24 18.5V21.8333C24 22.408 23.7717 22.9591 23.3654 23.3654C22.9591 23.7717 22.408 24 21.8333 24H10.1667C9.59203 24 9.04093 23.7717 8.6346 23.3654C8.22827 22.9591 8 22.408 8 21.8333V18.5C8 18.2239 8.22386 18 8.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.36636620a2ee1556e148123239fd16dc.svg";
export { ForwardRef as ReactComponent };